import { Alert, Collapse, Icon } from "@mui/material";

import { useAppSelector } from "~/hooks/reduxHooks";
import { isFailedOperation, isPendingOperation } from "~/store/offlineQueueSlice";

/**
 * Inline banner summarising in-flight offline work. Shows how many writes are queued/syncing and
 * how many failed, so a field worker can see at a glance that nothing has been lost. Hidden when
 * the queue is empty. Pairs with the History tab for the per-operation retry view.
 */
const SyncStatusBanner = () => {
	const operations = useAppSelector((state) => state.offlineQueue.operations);
	const pending = operations.filter(isPendingOperation);
	const failedCount = pending.filter(isFailedOperation).length;
	const queuedCount = pending.length - failedCount;

	const severity = failedCount > 0 ? "error" : "info";
	const iconName = failedCount > 0 ? "sync_problem" : "sync";

	const parts: string[] = [];
	if (queuedCount > 0) parts.push(`${queuedCount} waiting to sync`);
	if (failedCount > 0) parts.push(`${failedCount} need attention`);

	return (
		<Collapse in={pending.length > 0}>
			<Alert icon={<Icon sx={{ fontSize: 20 }}>{iconName}</Icon>} severity={severity} sx={{ borderRadius: 0 }}>
				{parts.join(" · ")}
			</Alert>
		</Collapse>
	);
};

export default SyncStatusBanner;
